import CommonDashboard from "./CommonDashboard";

const CommonDashboardConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/dashboard',
            element: <CommonDashboard/>,
        },

    ],
};

export default CommonDashboardConfig;
